import { useMemo, useState } from 'react'

type ReturnType = {
    data: Record<string, unknown>
    onClear(field: string): unknown
    setDataProp(prop): (val) => unknown
    setIsValidProp(prop): (val) => unknown
    setMultipleIsValidProps(obj): unknown
    isDataValid: Record<string, boolean>
    isFormDataValid: boolean
    setMultipleDataProps(obj): unknown
}

/**
 *
 */
const useFlatForm = (initialValue, initialValidationValue = {}): ReturnType => {
    const [data, setData] = useState(initialValue)
    const [isDataValid, isDataValidSetter] = useState(() => {
        if (!initialValue) return true
        const defaultFalsyValues = Object.keys(initialValue).reduce((a, c) => {
            a[c] = false
            return a
        }, {})

        return { ...defaultFalsyValues, ...initialValidationValue }
    })

    const onClear = (field) => () => setData((d) => ({ ...d, [field]: '' }))
    const setDataProp = (field) => (value) => setData((prevData) => ({ ...prevData, [field]: value }))
    const setMultipleDataProps = (obj) => setData((prevData) => ({ ...prevData, ...obj }))

    const setIsValidProp = (field) => (value) => {
        if (Object.prototype.hasOwnProperty.call(isDataValid, field)) {
            isDataValidSetter((prevData) => ({ ...prevData, [field]: value }))
        }
    }

    const setMultipleIsValidProps = (obj) => {
        isDataValidSetter((prevData) => ({ ...prevData, ...obj }))
    }

    const isFormDataValid = useMemo(() => Object.values(isDataValid).every((x) => x), [isDataValid])

    return {
        data,
        onClear,
        setDataProp,
        setIsValidProp,
        setMultipleIsValidProps,
        isDataValid,
        isFormDataValid,
        setMultipleDataProps
    }
}

export default useFlatForm
